import { Box } from '@user-portal/wikr-components';
import styled from 'styled-components';

import { mediaQueries } from 'theme/mediaQueries';

export const FlexWrapper = styled(Box)`
    display: flex;
`;

export const TabletWrapper = styled(Box)`
    display: none;

    ${mediaQueries.tabletLandscape} {
        display: block;
    }
`;

export const Footer = styled(FlexWrapper)`
    ${({ $mb }) => Number.isInteger($mb) && `margin-bottom: ${$mb}px;`};
    ${({ $paddingTop }) => Number.isInteger($paddingTop) && `padding-top: ${$paddingTop}px;`};
    ${({ $paddingBottom }) => Number.isInteger($paddingBottom) && `padding-bottom: ${$paddingBottom}px;`};
    ${({ $borderRadius }) => Number.isInteger($borderRadius) && `border-radius: ${$borderRadius}px;`};
    ${({ $paddingX }) => Number.isInteger($paddingX) && `padding-left: ${$paddingX}px; padding-right: ${$paddingX}px;`};
    ${({ theme, $backgroundColor }) => $backgroundColor && `background-color: ${theme[$backgroundColor]};`};
    align-items: center;
    justify-content: space-between;
`;
